export function formatDateTimeISO(
    iso,
    {
        timeZone = 'Asia/Seoul',
        dateStyle = 'medium', // "full" | "long" | "medium" | "short"
        timeStyle = 'short', // 초까지면 "medium"
        locale = 'ko-KR',
    } = {}
) {
    if (!iso) return '-';
    const d = new Date(iso); // "2025-08-19T05:27:59.014+00:00"
    if (isNaN(d)) return '-';
    return new Intl.DateTimeFormat(locale, { timeZone, dateStyle, timeStyle }).format(d);
}

export function toPeriodsFromYYYYMM(rows = []) {
    const monthsByYearMap = new Map(); // year -> Set("MM")

    rows.forEach((s) => {
        if (typeof s !== 'string') return;
        const [yStr, mStr] = s.split('/');
        const y = Number(yStr);
        const m = String(mStr ?? '').padStart(2, '0');
        if (!Number.isFinite(y) || m.length !== 2) return;

        if (!monthsByYearMap.has(y)) monthsByYearMap.set(y, new Set());
        monthsByYearMap.get(y).add(m);
    });

    // years 내림차순
    const years = Array.from(monthsByYearMap.keys()).sort((a, b) => b - a);
    // monthsByYear: "01".."12" 오름차순
    const monthsByYear = {};
    years.forEach((y) => {
        monthsByYear[y] = Array.from(monthsByYearMap.get(y)).sort();
    });

    // 최신값
    let latestYear, latestMonth;
    if (years.length > 0) {
        latestYear = years[0];
        const ms = monthsByYear[latestYear];
        if (ms && ms.length) latestMonth = ms[ms.length - 1];
    }

    return { years, monthsByYear, latestYear, latestMonth };
}
